import { RefObject, useCallback, useEffect } from 'react';

const useCallbackOnPasteFiles = ({
  callback,
  ref,
}: {
  callback: (files: File[]) => void;
  ref: RefObject<HTMLDivElement | null>;
}) => {
  const onPasteEvent = useCallback(
    (event: ClipboardEvent) => {
      if (!event.clipboardData) {
        return;
      }

      const items = event.clipboardData.items;

      if (!items) {
        return;
      }

      const files: File[] = [];

      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        if (item.kind === 'file') {
          const file = item.getAsFile();

          if (file) {
            files.push(file);
          }
        }
      }

      if (files.length > 0) {
        callback(files);
      }
    },
    [callback],
  );

  useEffect(() => {
    const element = ref.current;

    if (element) {
      element.addEventListener('paste', onPasteEvent);
    }

    return () => {
      if (element) {
        element.removeEventListener('paste', onPasteEvent);
      }
    };
  }, [onPasteEvent, ref]);
};

export default useCallbackOnPasteFiles;
